import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { portalApi } from "../../api/portalApi";

export function PortalSetPasswordForm({
  title,
  subtitle,
  endpoint,
  successMessage,
}: {
  title: string;
  subtitle: string;
  endpoint: string;
  successMessage: string;
}) {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!token) return setError("Link inválido — falta o token de acesso.");
    if (password.length < 8) return setError("A senha precisa ter pelo menos 8 caracteres.");
    if (password !== confirm) return setError("As senhas não coincidem.");

    setSubmitting(true);
    try {
      await portalApi.post(endpoint, { token, password });
      setDone(true);
    } catch {
      setError("Não foi possível concluir — o link pode ter expirado. Peça um novo.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div
        className="d-flex flex-column gap-3 p-4"
        style={{
          width: "min(380px, 90vw)",
          background: "var(--color-surface)",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-lg)",
        }}
      >
        <div>
          <h4 className="mb-1">{title}</h4>
          <p className="text-secondary mb-0" style={{ fontSize: 13 }}>
            {subtitle}
          </p>
        </div>

        {done ? (
          <>
            <div className="text-secondary" style={{ fontSize: 13.5 }}>
              {successMessage}
            </div>
            <button type="button" className="btn btn-primary" onClick={() => navigate("/portal/login")}>
              Ir para o login
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <div className="field">
              <label className="form-label" style={{ fontSize: 12 }}>
                Nova senha
              </label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="field">
              <label className="form-label" style={{ fontSize: 12 }}>
                Confirmar senha
              </label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </div>
            {error && (
              <div className="text-danger" style={{ fontSize: 12.5 }}>
                {error}
              </div>
            )}
            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
              {submitting ? "Salvando…" : "Definir senha"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
